<script setup lang="ts">
import LeButton from "@dsk/components/Button/LeButton.vue";
import LeFile from "@dsk/icons/LeFile.vue";

import type { DictsysInflectionScheme, DictsysWordclass } from "@/types";

import LeArticleInflectionSchemeButtonProvider from "./LeArticleInflectionSchemeButtonProvider.vue";

const props = defineProps<{
  language: string;
  headWord: string;
  wordclass: DictsysWordclass;
  inflectionScheme: DictsysInflectionScheme;
  schemeId: string;
}>();
</script>

<template>
  <LeArticleInflectionSchemeButtonProvider v-slot="{ isOpen, toggle }" v-bind="props">
    <div>
      <LeButton
        :aria-pressed="isOpen"
        aria-label="Bøjningsskema"
        size="small"
        variant="outline"
        color="neutral"
        lang="da"
        @click="toggle()"
      >
        <LeFile role="presentation" />
        Bøjningsskema
      </LeButton>
    </div>
  </LeArticleInflectionSchemeButtonProvider>
</template>
